import dayjs from "dayjs";
import { FORMAT_DATE } from "../formatDate";
import { DECISION_TYPE } from "../../interfaces";

  export function getDateToConstancy(fechaDeEgreso: string | Date, fechaVigHastaPoliza: string | Date): string {
    const now = new Date();
    const dischargeDate = new Date(fechaDeEgreso);
  
    const bienEnAlta = dischargeDate > now && dischargeDate.getTime() !== now.getTime();
  
    return bienEnAlta
      ? dayjs(fechaVigHastaPoliza).format(FORMAT_DATE.AR)
      : dayjs(fechaDeEgreso).format(FORMAT_DATE.AR);
  }

  /** SE INDICA SI EL BIEN/ASEGURADO ESTÁ VIGENTE */
  export function getInsuredIsValid(isValid: string): boolean {
    const isValidFlag = isValid.toUpperCase() === DECISION_TYPE.YES;
    return isValidFlag;
  }